import { render, staticRenderFns } from "./otherLogin.vue?vue&type=template&id=54d997a8&scoped=true&"
import script from "./otherLogin.vue?vue&type=script&lang=js&"
export * from "./otherLogin.vue?vue&type=script&lang=js&"
import style0 from "./otherLogin.vue?vue&type=style&index=0&id=54d997a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d997a8",
  null
  
)

export default component.exports